import { Box } from "@material-ui/core";

interface MechanicalLoadDiagramProps {
    onSelectRow: (rowName: string) => void;
}

export const MechanicalLoadDiagram = ({
    onSelectRow,
}: MechanicalLoadDiagramProps) => {
    return (
        <Box display="flex" justifyContent="center" mb={2}>
            <svg
                width="600"
                height="350"
                viewBox="0 0 750 600"
                xmlns="http://www.w3.org/2000/svg"
            >
                {/* Background */}
                <rect x="0" y="80" width="750" height="450" fill="#E85B4A" />
                <rect x="22" y="102" width="703" height="401" fill="#17A9C6" />

                {/* Center Jig Area */}
                <rect
                    x="338"
                    y="0"
                    width="65"
                    height="600"
                    fill="#D9D9D9"
                    opacity="0.7"
                    stroke="#8E8E8E"
                />

                {/* Center dashed line */}
                <line
                    x1="370"
                    y1="40"
                    x2="370"
                    y2="560"
                    stroke="#9E9E9E"
                    strokeWidth="2"
                    strokeDasharray="8 8"
                />

                {/* J-Box */}
                <rect x="352" y="250" width="35" height="105" fill="#3B82F6" />

                <text
                    x="370"
                    y="305"
                    fill="white"
                    fontSize="16"
                    textAnchor="middle"
                    transform="rotate(-90 370 305)"
                >
                    J-box
                </text>

                {/* D1 */}
                <g
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectRow("Center deflection AVG")}
                >
                    <polygon
                        points="430,232 445,232 455,242 455,258 445,268 430,268 420,258 420,242"
                        fill="#0057D9"
                    />

                    <text
                        x="438"
                        y="252"
                        fill="white"
                        fontSize="16"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        d1
                    </text>
                </g>
                <circle cx="438" cy="302" r="19" fill="#FFC8D2" stroke="#000" strokeWidth="2" />

                {/* D3 */}
                <g
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectRow("Edge d3 deflection AVG")}
                >
                    <polygon
                        points="610,232 625,232 635,242 635,258 625,268 610,268 600,258 600,242"
                        fill="#0057D9"
                    />
                    <text
                        x="618" y="254"
                        fill="white"
                        fontSize="16"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        d3
                    </text>
                </g>
                <circle cx="618" cy="300" r="19" fill="#47F2D5" stroke="#000" strokeWidth="2" />

                {/* D2 */}

                <g
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectRow("Edge d2 deflection AVG")}
                >
                    <polygon
                        points="690,232 705,232 715,242 715,258 705,268 690,268 680,258 680,242"
                        fill="#0057D9"
                    />


                    <text
                        x="698" y="254"
                        fill="white"
                        fontSize="16"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        d2
                    </text>
                </g>
                <circle cx="702" cy="298" r="19" fill="#E4C300" stroke="#000" strokeWidth="2" />

                {/* D4 */}

                <g
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectRow("Edge d4 deflection AVG")}
                >
                    <polygon
                        points="110,232 125,232 135,242 135,258 125,268 110,268 100,258 100,242"
                        fill="#0057D9"
                    />
                    <text
                        x="118" y="254"
                        fill="white"
                        fontSize="16"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        d4
                    </text>
                </g>
                <circle cx="120" cy="302" r="19" fill="#47F2D5" stroke="#000" strokeWidth="2" />

                {/* D5 */}
                <g
                    style={{ cursor: "pointer" }}
                    onClick={() => onSelectRow("Edge d5 deflection AVG")}
                >
                    <polygon
                        points="30,232 45,232 55,242 55,258 45,268 30,268 20,258 20,242"
                        fill="#0057D9"
                    />
                    <text
                        x="38" y="254"
                        fill="white"
                        fontSize="16"
                        fontWeight="bold"
                        textAnchor="middle"
                        dominantBaseline="middle"
                    >
                        d5
                    </text>
                </g>
                <circle cx="46" cy="302" r="19" fill="#E4C300" stroke="#000" strokeWidth="2" />

                {/* Arrow markers */}
                <defs>
                    <marker
                        id="arrowStart"
                        markerWidth="4"
                        markerHeight="4"
                        refX="1"
                        refY="2"
                        orient="auto"
                    >
                        <path
                            d="M4,0 L0,2 L4,4 Z"
                            fill="context-stroke"
                        />
                    </marker>

                    <marker
                        id="arrowEnd"
                        markerWidth="4"
                        markerHeight="4"
                        refX="3"
                        refY="2"
                        orient="auto"
                    >
                        <path
                            d="M0,0 L4,2 L0,4 Z"
                            fill="context-stroke"
                        />
                    </marker>
                </defs>

                {/* 15 cm */}
                <line
                    x1="370"
                    y1="370"
                    x2="438"
                    y2="370"
                    stroke="#FFD1DC"
                    strokeWidth="3"
                    markerStart="url(#arrowStart)"
                    markerEnd="url(#arrowEnd)"
                />
                <text
                    x="404"
                    y="360"
                    fill="#FFD1DC"
                    fontSize="16"
                    fontWeight="bold"
                    textAnchor="middle"
                >
                    15 cm
                </text>

                {/* 75 cm */}
                <line
                    x1="370"
                    y1="405"
                    x2="618"
                    y2="405"
                    stroke="#A6F7D5"
                    strokeWidth="3"
                    markerStart="url(#arrowStart)"
                    markerEnd="url(#arrowEnd)"
                />
                <text
                    x="494"
                    y="395"
                    fill="#A6F7D5"
                    fontSize="16"
                    fontWeight="bold"
                    textAnchor="middle"
                >
                    75 cm
                </text>

                {/* 105 cm */}
                <line
                    x1="370"
                    y1="440"
                    x2="702"
                    y2="440"
                    stroke="#F5C400"
                    strokeWidth="3"
                    markerStart="url(#arrowStart)"
                    markerEnd="url(#arrowEnd)"
                />
                <text
                    x="536"
                    y="430"
                    fill="#F5C400"
                    fontSize="16"
                    fontWeight="bold"
                    textAnchor="middle"
                >
                    105 cm
                </text>

                {/* Bottom 15 cm */}
                <line
                    x1="338"
                    y1="565"
                    x2="403"
                    y2="565"
                    stroke="#006DFF"
                    strokeWidth="3"
                    markerStart="url(#arrowStart)"
                    markerEnd="url(#arrowEnd)"
                />
                <text
                    x="370"
                    y="592"
                    fill="#006DFF"
                    fontSize="16"
                    fontWeight="bold"
                    textAnchor="middle"
                >
                    15 cm
                </text>
            </svg>
        </Box>
    );
};